//  danmckeown.info #5 copyright 2017-2018
//  random.js
//  updated for mlBench
import React, { Component } from "react";
import Header from "./header-new2021front";
import Footer from "./footer-newerfront";

import { v4 as uuidv4 } from 'uuid';

//  const bip39 = require('bip39');

let words = require('an-array-of-english-words')
 
let ObjectID = require("bson-objectid");


const numberScale = 100000000000000;


function math_floor_random_number(scale) {
  var newdigit = Math.floor((Math.random() * scale) + 1);
  return newdigit;
}

function reloadOnce() {
  console.log("about to reload");
  return window.location.reload();
  return false;
}

function miniID() {
  return 0;
}

class Random extends Component {

  constructor() {
    super();
    this.state = {"uuidGenerated": uuidv4(), nanoID: this.miniID(), cryptonowNH: Number, mongoID: ObjectID(), wordSet: this.getWords(), wordSetPlus: this.getWordsPlus()}
    this.x = `<header id='topheader'>
    <nav id='topnav'>
        <ul id='navlist'>
            <li><a href='https://djmblog.com'>djmblog</a></li>
            <li><a href='https://blockfowl.com'>blockfowl</a></li>
        </ul>
      </nav>
  </header>`;
 
  }

  getWords() {
    let wordsArrayLength = words.length;
    let word1key = math_floor_random_number(wordsArrayLength);
    let word2key = math_floor_random_number(wordsArrayLength);
    let word3key = math_floor_random_number(wordsArrayLength);
    let word4key = math_floor_random_number(wordsArrayLength);
    return `${words[Number(word1key)]}-${words[Number(word2key)]}-${words[Number(word3key)]}-${words[Number(word4key)]}`;
  }
  getWordsPlus() {
    let wordsArrayLength = words.length;
    let word1key = math_floor_random_number(wordsArrayLength);
    let word2key = math_floor_random_number(wordsArrayLength);
    let word3key = math_floor_random_number(wordsArrayLength);
    // let word4key = math_floor_random_number(wordsArrayLength);
    let pwstring = math_floor_random_number(5);
    return `${words[Number(word1key)]}-${words[Number(word2key)]}-${words[Number(word3key)]}-${pwstring}`;
  }

  

  goBack() {
    window.history.back();
  }

  miniID() {
    let starterSeed = this.getWordsPlus() + math_floor_random_number(100);
    let starterSalt = uuidv4();
    console.log("starterSeed: " + starterSeed);
    console.log(starterSalt);
    let starterDough = starterSeed + starterSalt;
    let parameter1 = math_floor_random_number(25);
    let parameter2 = parameter1 + 3 + math_floor_random_number(34);
    let mix1 = starterDough.substring(parameter1, parameter2);
    return mix1;
  }
  
  UNSAFE_componentWillMount() {
    var newCrypto3 = math_floor_random_number(numberScale);
    this.setState((prevState) => ({
      cryptonowNumber: newCrypto3
    }));
  }
  componentDidMount() {
  //  this.getCryptoNow();

    let freshObjectID = ObjectID();
    console.log(freshObjectID);
    this.setState({mongoID: freshObjectID});

    this.setState({wordSet: this.getWords()});
  }
  render() {
   
    return (
      <>
        <Header />
        <div id="randomStringGenerator" className="content">

          <button id="backButton" href="#" onClick={this.goBack}>⬅️ back</button>
          
          <h1>random number <span className="modifier">(via <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/floor">Math.floor()</a>)</span> <span className="rollLink"><a href="#" onClick={reloadOnce}>roll it</a></span></h1>
          <section id="randomSection3">
            <textarea id="math_floor_outputNumber">{this.state.cryptonowNumber}</textarea>
          </section>
 
          <h1 id="random-cspring">Words <span id="getOne" className="modifier"><a href="../1word">get 1</a></span> <span className="modifier">(via <a href="https://www.npmjs.com/package/an-array-of-english-words">NPM an-array-of-english-words</a>)</span> <span className="rollLink"><a href="#" onClick={reloadOnce}>roll it</a></span></h1>
          <section id="randomSection6">
            <textarea className="wideTextArea" id="words_outputScalar">{this.state.wordSet}</textarea>
          </section>
       
          <h1 id="random-cspring">UUID <span className="modifier">(via <a href="https://www.npmjs.com/package/uuid">NPM uuid</a>)</span> <span className="rollLink"><a href="#" onClick={reloadOnce}>roll it</a></span></h1>
          <section id="randomSection8">
            <textarea id="uuid_outputScalar">{this.state.uuidGenerated}</textarea>
          </section>
          <h1 id="random-cspring">miniID <span className="modifier"></span> <span className="rollLink"><a href="#" onClick={reloadOnce}>roll it</a></span></h1>
          <section id="randomSection80">
            <textarea id="uuid_outputScalar_miniID">{this.state.nanoID}</textarea>
          </section>
          <h1 id="random-cspring">MongoDB ID <span className="modifier">(via <a href="https://www.npmjs.com/package/bson-objectid">NPM bson-objectid</a>)</span> <span className="rollLink"><a href="#" onClick={reloadOnce}>roll it</a></span></h1>
          <section id="randomSection9">
            <textarea id="uuid_mongo">{this.state.mongoID}</textarea>
          </section>
          

          <style>
            {`
            div.content {
              font-family: "Hack", "Fira Code", "Anonymous Pro", monospace;
              padding-left: calc(1em + 1vw + 1px + 1vh);;
              padding-top: calc(1em + 1vw + 1px + 1vh);
              background: #bae6ff;
            }
            div.content a {
              font-size: calc(0.9rem);
            }
            div.content section textarea {
              width: calc(30vw + 2pt);
              height: calc(8vh + 2pt);
              font-size: calc(1.85rem);
            }
            div.content section textarea#uuid_outputScalar, div.content section textarea.wideTextArea {
              width: calc(39vw + 50pt);
              height: calc(8vh + 2pt);
              font-size: calc(1.85rem);
            }
            div.content section textarea#seedPhrase {
              width: calc(39vw + 40pt);
              height: calc(12vh + 2pt);
              font-size: calc(1.85rem);
            }
            div.content span#ascii-note {
              font-size: calc(0.7rem);
              font-family: "Open Sans", "Lato", Helvetica, sans-serif;
            }
            span.modifier {
              font-size: calc(0.8rem);
            }
            .rollLink a {
              color: #a48de0;
            }
            span#getOne, span#getOne a {
              color: gray;
            }
          `}
          </style>
        </div>
        <Footer />
      </>
    );
  }
}

export default Random
